/**
 * JWT payload decoding (no external library).
 * Used by login flows and session builders — keep one implementation for the whole app.
 */

export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return {};
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return {};
  }
}
